enum Daypart {
  LF = 'Late Fringe',
  ON = 'Overnight',
  EM = 'Early Morning',
  DT = 'Daytime',
  EF = 'Early Fringe',
  PT = 'Primetime',
}

export default Daypart;
